
/**
 * Opens a new browser tab with the current's base URL, plus a given path and query parameters.
 *
 * @param {string} path - (string) The path to append after the current base URL (e.g., "profile").
 * @param {object[]} queryParams - (array of {user: '...', active: '...'}) An object representing query parameters.
 * @example
 * // If current URL is https://example.com/app
 * openNewTab("profile", { user: "john", active: true });
 * // Opens: https://example.com/profile?user=john&active=true
 */
function openNewTab(path, queryParams = {}) {
    const baseUrl = window.location.origin;
    const url = new URL(path, baseUrl);
  
    // Append query parameters
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.append(key, String(value));
    });
  
    // Open in new tab
    window.open(url.toString(), "_blank");
  }
  

  export default openNewTab;